import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import './SearchCars.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import SearchCarsSection from "../Components/SearchCarsSection";

const SearchResult = () => {
    const navigate = useNavigate();
    
    const location = useLocation();
    const {
        maker,
        model,
        yearFrom,
        yearTo,
        priceFrom,
        priceTo,
        vin,
        mileage,
        fuel,
        transmission,
        bodyType,
        color,
    } = location.state || {};
    const [cars, setCars] = useState([]);

    useEffect(() => {
        let url = `https://api.mitradingjp.com/getCars.php?maker=${maker}`;
        if (model) {
            url += `&model=${model}`;
        }
        if (yearFrom) {
            url += `&yearFrom=${yearFrom}`;
        }
        if (yearTo) {
            url += `&yearTo=${yearTo}`;
        }
        if (priceFrom) {
            url += `&priceFrom=${priceFrom}`;
        }
        if (priceTo) {
            url += `&priceTo=${priceTo}`;
        }
        if (vin) {
            url += `&vin=${vin}`;
        }
        if (mileage) {
            url += `&mileage=${mileage}`;
        }
        if (fuel) {
            url += `&fuel=${fuel}`;
        }
        if (transmission) {
            url += `&transmission=${transmission}`;
        }
        if (bodyType) {
            url += `&bodyType=${bodyType}`;
        }
        if (color) {
            url += `&color=${color}`;
        }

        fetch(url)
            .then(response => response.json())
            .then(data => setCars(data))
            .catch(error => console.error('Error fetching cars:', error));
    }, [maker, model, yearFrom, yearTo, priceFrom, priceTo, vin, mileage, fuel, transmission, bodyType, color]);

    const handleViewVehicle = (carId) => {
        navigate(`/vehicle-details/${carId}`);
    };

    return (
        <>
            <div className="row">
                <div className="col-1 leftcol">
                    {/* <HomeLeft /> */}
                </div>
                <div className="col-10 middlecol">
                    <HomeSearchbar />
                    <SearchCarsSection />
                    <hr className="title-line"></hr>
                    {cars.map((car) => (
                        <div key={car.id}>
                            <div className="row car-show">
                                <div className="col-lg-4">
                                    <img
                                        src={`https://api.mitradingjp.com/${car.images}`}
                                        alt={car.model}
                                        onClick={() => handleViewVehicle(car.id)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                                <div className="col-lg-6">
                                    <h3>{car.maker} {car.model} {car.year}</h3>
                                    <p>Location: {car.country}</p>
                                    <h4>&#xa5; {car.price}</h4>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Engine</th>
                                                <td>{car.engine_size} CC</td>
                                            </tr>
                                            <tr>
                                                <th>Transmission</th>
                                                <td>{car.transmission}</td>
                                            </tr>
                                            <tr>
                                                <th>Color</th>
                                                <td>{car.color}</td>
                                            </tr>
                                            <tr>
                                                <th>Fuel</th>
                                                <td>{car.fuel}</td>
                                            </tr>
                                            <tr>
                                                <th>Mileage</th>
                                                <td>{car.mileage} KM</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-lg-2">
                                    <button>Get Price Quote</button>
                                    <button onClick={() => handleViewVehicle(car.id)}>View Vehicle</button>
                                </div>
                            </div>
                            <hr className="title-line"></hr>
                        </div>
                    ))}
                    
                </div>
                <div className="col-1 rightcol">
                    {/* <HomeRight /> */}
                </div>
            </div>
        </>
    );
};

export default SearchResult;